import React from "react";
import {makeStyles, Typography, useMediaQuery} from "@material-ui/core";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Icon from '@material-ui/core/Icon/Icon';

const useStyles = makeStyles(
    (theme: any) => {
        return {
            LandscapeFullscreen: {
                display: 'flex',
                position: 'absolute',
                top: 42,
                left: 10,
                zIndex: 6,
                margin: '-8px',
            },
            ContentWrapper: {
                display: 'flex',
                alignItems: 'center',
                margin: '0 auto',
                padding: '0 8px',

                '& span': {
                    display: 'block',
                },
            },
            iconRotate: {
                fontSize: 18,
                margin: 8,
            },
            textRotate: {
                fontWeight: "bold",
                fontSize: "0.7rem",
            },
            '@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 825px)': {
                LandscapeFullscreen: {
                    display: 'flex',
                    position: 'absolute',
                    top: 25,
                    width: '100%',
                    zIndex: 6,
                    margin: '-8px',
                },
            },
        };
    },
    {
        name: "LandscapeInformation",
    }
);

const LandscapeInformation = ({}) => {
    const isSmallerScreen = useMediaQuery(
        "(max-device-width : 430px)"
    );
    const classes = useStyles({});
    const isLandscapeMode = useMediaQuery('@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 825px)');
    const text = isLandscapeMode ? t('rotationInstructions') : t('custom.landscape.preview');
    if (!isSmallerScreen && !isLandscapeMode) {
        return null;
    }
    return (
        <div className={classes.LandscapeFullscreen}>
            <div className={classes.ContentWrapper}>
                <Icon className={classes.iconRotate}>screen_rotation</Icon>
                <Typography className={classes.textRotate}>{text}</Typography>
            </div>
        </div>
)};

export default LandscapeInformation;
